// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSickLeaveUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_4564_301559)">
					<path
						d="M7.22998 8.33005L7.91998 11.09L12.24 10.61L16.67 11.09L17.48 8.45005L12.73 7.30005L7.22998 8.33005Z"
						fill="#335FC1"
					/>
					<path
						d="M17.77 9.44989L17.93 8.88989C18 8.63989 17.97 8.37989 17.84 8.14989C17.69 7.87989 17.41 7.67989 17.09 7.59989C13.97 6.81989 10.66 6.81989 7.54 7.59989C7.22 7.67989 6.95 7.87989 6.79 8.14989C6.66 8.37989 6.62 8.64989 6.7 8.88989L6.86 9.44989C5.66 10.7899 5 12.5199 5 14.3299C5 18.3599 8.28 21.6499 12.32 21.6499C16.36 21.6499 19.64 18.3699 19.64 14.3299C19.64 12.5099 18.98 10.7999 17.78 9.44989H17.77ZM7.56 8.58989C7.6 8.52989 7.67 8.47989 7.76 8.45989C10.74 7.70989 13.9 7.70989 16.89 8.45989C16.98 8.47989 17.05 8.52989 17.09 8.58989C17.1 8.60989 17.11 8.62989 17.1 8.64989L16.52 10.6499C16.49 10.7399 16.39 10.7699 16.31 10.7499C15.01 10.4199 13.67 10.2599 12.32 10.2599C10.97 10.2599 9.64 10.4299 8.33 10.7499C8.25 10.7699 8.15 10.7299 8.13 10.6499L7.55 8.63989C7.55 8.63989 7.55 8.60989 7.56 8.57989V8.58989ZM12.32 20.7699C8.77 20.7699 5.88 17.8799 5.88 14.3299C5.88 12.9299 6.33 11.5799 7.16 10.4799L7.28 10.9099C7.41 11.3399 7.82 11.6499 8.28 11.6499C8.37 11.6499 8.45 11.6399 8.54 11.6199C11 10.9999 13.62 10.9999 16.08 11.6199C16.16 11.6399 16.25 11.6499 16.34 11.6499C16.8 11.6499 17.21 11.3499 17.34 10.9099L17.46 10.4799C18.29 11.5899 18.74 12.9299 18.74 14.3399C18.74 17.8899 15.85 20.7799 12.3 20.7799L12.32 20.7699Z"
						fill="black"
					/>
					<path
						d="M12.2799 17.15C11.1099 17.42 10.1099 17.66 9.18988 16.73C9.01988 16.56 8.73988 16.56 8.56988 16.73C8.39988 16.9 8.39988 17.18 8.56988 17.35C9.82988 18.62 11.2399 18.3 12.4799 18.01C13.5999 17.75 14.5699 17.52 15.4699 18.31C15.5499 18.38 15.6599 18.42 15.7599 18.42C15.8799 18.42 15.9999 18.37 16.0899 18.27C16.2499 18.09 16.2299 17.81 16.0499 17.65C14.8199 16.56 13.4699 16.87 12.2799 17.15Z"
						fill="black"
					/>
					<path
						d="M15.89 12.4999C15.8 12.5499 15.56 12.5999 15.24 12.4899C14.92 12.3799 14.75 12.1999 14.72 12.0999C14.64 11.8699 14.39 11.7499 14.16 11.8299C13.93 11.9099 13.81 12.1599 13.89 12.3899C14.03 12.7899 14.43 13.1399 14.95 13.3199C15.18 13.3999 15.41 13.4399 15.62 13.4399C15.9 13.4399 16.15 13.3699 16.36 13.2499C16.56 13.1199 16.62 12.8499 16.49 12.6399C16.36 12.4399 16.09 12.3799 15.88 12.5099L15.89 12.4999Z"
						fill="black"
					/>
					<path
						d="M9.6799 13.3199C10.1999 13.1399 10.5999 12.7899 10.7399 12.3899C10.8199 12.1599 10.6999 11.9099 10.4699 11.8299C10.2399 11.7499 9.9899 11.8699 9.9099 12.0999C9.8799 12.1999 9.7099 12.3799 9.3899 12.4899C9.0699 12.5999 8.8299 12.5599 8.7399 12.4999C8.5399 12.3699 8.2599 12.4299 8.1299 12.6299C7.9999 12.8299 8.0599 13.1099 8.2599 13.2399C8.4599 13.3699 8.7199 13.4299 8.9999 13.4299C9.2199 13.4299 9.4399 13.3899 9.6699 13.3099L9.6799 13.3199Z"
						fill="black"
					/>
					<path
						d="M9.89001 4.53C9.89001 4.79 9.79001 4.91 9.57001 5.13C9.46001 5.25 9.33001 5.38 9.23001 5.55C9.10001 5.76 9.17001 6.03 9.37001 6.15C9.44001 6.19 9.52001 6.22 9.60001 6.22C9.75001 6.22 9.89001 6.15 9.97001 6.01C10.03 5.92 10.11 5.84 10.2 5.74C10.44 5.49 10.76 5.16 10.76 4.53C10.76 3.9 10.43 3.56 10.2 3.32C9.99001 3.1 9.88001 2.98 9.88001 2.72C9.88001 2.46 9.98001 2.34 10.2 2.12C10.32 2 10.46 1.85 10.57 1.67C10.69 1.46 10.62 1.19 10.41 1.07C10.2 0.949998 9.93001 1.02 9.81001 1.23C9.75001 1.33 9.67001 1.41 9.57001 1.51C9.33001 1.76 9.01001 2.09 9.01001 2.72C9.01001 3.35 9.34001 3.69 9.57001 3.93C9.78001 4.15 9.89001 4.27 9.89001 4.53Z"
						fill="black"
					/>
					<path
						d="M12.3199 4.53C12.3199 4.79 12.2199 4.91 11.9999 5.13C11.8899 5.25 11.7599 5.38 11.6599 5.55C11.5299 5.76 11.5999 6.03 11.7999 6.15C11.8699 6.19 11.9499 6.22 12.0299 6.22C12.1799 6.22 12.3199 6.15 12.3999 6.01C12.4599 5.92 12.5399 5.84 12.6299 5.74C12.8699 5.49 13.1899 5.16 13.1899 4.53C13.1899 3.9 12.8599 3.56 12.6299 3.32C12.4199 3.1 12.3099 2.98 12.3099 2.72C12.3099 2.46 12.4099 2.34 12.6299 2.12C12.7499 2 12.8899 1.85 12.9999 1.67C13.1199 1.46 13.0499 1.19 12.8399 1.07C12.6299 0.949998 12.3599 1.02 12.2399 1.23C12.1799 1.33 12.0999 1.41 11.9999 1.51C11.7599 1.76 11.4399 2.09 11.4399 2.72C11.4399 3.35 11.7699 3.69 11.9999 3.93C12.2099 4.15 12.3199 4.27 12.3199 4.53Z"
						fill="black"
					/>
					<path
						d="M14.7501 4.53C14.7501 4.79 14.6501 4.91 14.4301 5.13C14.3201 5.25 14.1901 5.38 14.0901 5.55C13.9601 5.76 14.0301 6.03 14.2301 6.15C14.3001 6.19 14.3801 6.22 14.4601 6.22C14.6101 6.22 14.7501 6.15 14.8301 6.01C14.8901 5.92 14.9701 5.84 15.0601 5.74C15.3001 5.49 15.6201 5.16 15.6201 4.53C15.6201 3.9 15.2901 3.56 15.0601 3.32C14.8501 3.1 14.7401 2.98 14.7401 2.72C14.7401 2.46 14.8401 2.34 15.0601 2.12C15.1801 2 15.3201 1.85 15.4301 1.67C15.5501 1.46 15.4801 1.19 15.2701 1.07C15.0601 0.949998 14.7901 1.02 14.6701 1.23C14.6101 1.33 14.5301 1.41 14.4301 1.51C14.1901 1.76 13.8701 2.09 13.8701 2.72C13.8701 3.35 14.2001 3.69 14.4301 3.93C14.6401 4.15 14.7501 4.27 14.7501 4.53Z"
						fill="black"
					/>
				</g>
				<defs>
					<clipPath id="clip0_4564_301559">
						<rect width={14.63} height={20.64} fill="white" transform="translate(5 1)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgSickLeaveUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSickLeaveUnique24;
